import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { Box, Paper } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import BarChartIcon from '@mui/icons-material/BarChart';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DocumentMSStyle from './DocumentMSStyle';
import Allservices from '../Allservices';
import Footer from '../../Homepage/Footer';
import DashboardSummary from './DashboardSummary';
import ActivityLog from './ActivityLog';

const blue = {
  50: "#131C4C",
  100: "#C2E0FF",
  200: "#FFFFFF",
  300: "#66B2FF",
  400: "#EBE3CA",
  500: "#EBE3CA",
  600: "#FFFFFF",
  700: "#0059B2",
  800: "#004C99",
  900: "#003A75",
};

const Tab = styled(TabUnstyled)`
  font-family: 'Montserrat', sans-serif;
  color: #131C4C;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  background-color: transparent;
  width: auto;
  padding: 10px 20px;
  border: none;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 44px;
  white-space: nowrap;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(235, 227, 202, 0.5);
  }

  &:focus {
    outline: none;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${blue[50]};
    color: ${blue[600]};
    font-weight: 700;
    box-shadow: 0 2px 4px rgba(19, 28, 76, 0.1);
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  padding-top: 24px;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: auto;
  width: fit-content;
  background-color: ${blue[500]};
  border-radius: 14px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 4px;
  height: auto;
  gap: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

const DocumentMS = (props) => {
  const { classes } = props;
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  // Hide location section on mount
  useEffect(() => {
    const locationElements = document.querySelectorAll('.location, .location-text');
    locationElements.forEach(el => {
      if (el.closest('.location')) {
        el.style.display = 'none';
      }
    });
    
    return () => {
      // Restore on unmount if needed
      locationElements.forEach(el => {
        el.style.display = '';
      });
    };
  }, []);

  // Check privilege on mount and redirect if not authorized
  useEffect(() => {
    const privilege = localStorage.getItem('previlage') || sessionStorage.getItem('previlage');
    const hasDmsAccess = privilege === 'dms_user' || privilege === 'dms_admin';
    if (!hasDmsAccess) {
      navigate('/services');
    }
  }, [navigate]);

  return (
    <>
      <style>
        {`
          .location {
            display: none !important;
          }
          .location-text {
            display: none !important;
          }
        `}
      </style>
      <Allservices />
      <Box style={{ backgroundColor: '#F9FAFB', minHeight: '100vh', paddingTop: '24px' }}>
        <Box className={classes.container}>
          <Box className={classes.header}>
            <h1 className={classes.title}>Document Management System</h1>
          </Box>

          <Paper 
            className={classes.card}
            style={{
              borderRadius: '16px',
              padding: '32px',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
              backgroundColor: '#FFFFFF',
            }}
          >
            <TabsUnstyled value={activeTab}>
              <TabsList>
                <Tab value={0} onClick={() => setActiveTab(0)}>
                  <DashboardIcon style={{ fontSize: '18px' }} />
                  Overview
                </Tab>
                <Tab value={1} onClick={() => setActiveTab(1)}>
                  <BarChartIcon style={{ fontSize: '18px' }} />
                  Reports
                </Tab>
              </TabsList>

              {activeTab === 0 && (
                <TabPanel value={0}>
                  <DashboardSummary />
                </TabPanel>
              )}
              {activeTab === 1 && (
                <TabPanel value={1}>
                  <ActivityLog />
                </TabPanel>
              )}
            </TabsUnstyled>
          </Paper>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default withStyles(DocumentMSStyle)(DocumentMS);
